export function arraysEqual(arr1: string[] = [], arr2: string[] = []) {
  const sortedArr1 = [...arr1].sort()
  const sortedArr2 = [...arr2].sort()

  return (
    sortedArr1.length === sortedArr2.length &&
    sortedArr1.every((value, index) => value === sortedArr2[index])
  )
}
